export const MOBILE_BREAKPOINT = 768;
export const WIDE_DESKTOP_BREAKPOINT = 1440;
